import type { CSSProperties } from 'react';

export const input: CSSProperties = {
  width: '100%',
  boxSizing: 'border-box',
  fontSize: 13,
  padding: '6px 8px',
  border: '0.5px solid var(--color-border-secondary)',
  borderRadius: 'var(--border-radius-md)',
  backgroundColor: 'var(--color-background-primary)',
  color: 'var(--color-text-primary)',
};

export const select: CSSProperties = {
  width: '100%',
  boxSizing: 'border-box',
  fontSize: 13,
  padding: '6px 8px',
  border: '0.5px solid var(--color-border-secondary)',
  borderRadius: 'var(--border-radius-md)',
  backgroundColor: 'var(--color-background-primary)',
  color: 'var(--color-text-primary)',
};

export const textarea = (height = 60): CSSProperties => ({
  width: '100%',
  boxSizing: 'border-box',
  fontSize: 13,
  padding: '6px 8px',
  border: '0.5px solid var(--color-border-secondary)',
  borderRadius: 'var(--border-radius-md)',
  backgroundColor: 'var(--color-background-primary)',
  color: 'var(--color-text-primary)',
  height,
  resize: 'vertical',
});

export const button: CSSProperties = {
  padding: '6px 12px',
  fontSize: 13,
  fontWeight: 500,
  borderRadius: 'var(--border-radius-md)',
  border: 'none',
  backgroundColor: 'var(--color-accent)',
  color: '#ffffff',
  cursor: 'pointer',
};
